import type { PillConfig } from '#types/config/components/vf/pill'
import type { RecursivePartial } from '#types/utils'

export default {
  removeIconSecondary: 'clear-filled'
} satisfies RecursivePartial<PillConfig>
